import { Dropdown } from "./Dropdown";
import { useStateWithSearchParams } from "../../../hooks";

type Props = {
  query: string;
  items: string[];
  label: string;
  placeholder: string;
  maxHeight?: string;
  maxItemsWidth?: string;
  initSelected?: string;
  selectedAllOption?: string;
  isDisabled?: boolean;
};

type SearchParams = {
  [key: string]: string | undefined;
};

export const DropdownWithQuery = ({
  query,
  items,
  label,
  placeholder,
  maxHeight = "124px",
  maxItemsWidth = "100%",
  initSelected = "",
  selectedAllOption,
  isDisabled,
}: Props) => {
  const { searchDict, setSearchValue } = useStateWithSearchParams<SearchParams>(
    {
      [query]: undefined,
    },
  );

  return (
    <Dropdown
      isDisabled={isDisabled}
      label={label}
      placeholder={placeholder}
      selectedItem={{ value: searchDict[query] ?? initSelected }}
      items={items.map((value) => ({ value }))}
      onChange={({ value }) =>
        setSearchValue(query, selectedAllOption === value ? undefined : value)
      }
      maxHeight={maxHeight}
      maxItemsWidth={maxItemsWidth}
    />
  );
};
